import React from 'react';
import { Field, reduxForm, stopSubmit } from 'redux-form';
import { Form, FormGroup, Label, Alert } from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import SelectDropdown from '../../system/fields/SelectDropdown';
import * as validations from '../../system/utils/Validation';

let EditForm = (props, { fields }) => {
  const { handleSubmit, mode } = props;

  return (
    <section className='edit-form'>
      <Form onSubmit={handleSubmit}>
        <section className='form-section'>
          <div className='form-section-header'>Create a payment request</div>

          <div className='row'>
            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='first_name'>First Name</Label>
              <Field
                name='first_name'
                component={TextInput}
                placeholder='First Name'
                type='text'
                validate={validations.required}
                autoFocus={true}
              />
            </FormGroup>

            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='last_name'>Last Name</Label>
              <Field
                name='last_name'
                placeholder='Last Name'
                component={TextInput}
                type='text'
                validate={validations.required}
              />
            </FormGroup>
          </div>

          <div className='row'>
            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='price'>Price</Label>
              <Field
                name='price'
                placeholder='Price'
                component={TextInput}
                type='number'
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='email'>Email Address</Label>
              <Field
                name='email'
                placeholder='Email'
                component={TextInput}
                type='email'
                validate={[validations.required, validations.email]}
              />
            </FormGroup>
          </div>

          <div className='row'>
            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='booking_id'>Booking ID</Label>
              <Field
                name='booking_id'
                placeholder='Booking ID'
                component={TextInput}
                type='text'
                validate={validations.required}
              />
            </FormGroup>
            <FormGroup className='col-12 col-sm-6'>
              <Label htmlFor='site'>Site</Label>
              <Field
                name='site'
                component={SelectDropdown}
                options={[
                  { id: 1, name: 'Viva Holidays' },
                  { id: 2, name: 'Viva Cruise' },
                  { id: 3, name: 'Weekender Breaks' },
                ]}
                labelKey='name'
                valueKey='id'
                placeholder='Select a Site'
                validate={validations.required}
              />
            </FormGroup>
            {props.mode === "edit" && (
              <FormGroup className='col-12 col-sm-6'>
                <Label htmlFor='status'>Status</Label>
                <Field
                  name='status_id.name'
                  component={TextInput}
                  placeholder='N/A'
                  type='text'
                  autoFocus={true}
                  disabled={true}
                />
              </FormGroup>
            )}
            {props.mode === "edit" && (
              <FormGroup className='col-12 col-sm-6'>
                <Label htmlFor='status'>Payment Link</Label>
                <Field
                  name='payment_link'
                  component={TextInput}
                  placeholder='N/A'
                  type='text'
                  autoFocus={true}
                  disabled={true}
                />
              </FormGroup>
            )}
          </div>
        </section>
      </Form>

      {props.submitFailed && (
        <div className='error-container'>
          <Alert color='danger'>
            <strong>There are errors in your form.</strong>
            <br />
            Please check before submitting again.
          </Alert>
        </div>
      )}
    </section>
  );
};

EditForm = reduxForm({
  form: 'TestForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('TestForm'));
    }
  },
})(EditForm);

export default EditForm;



// WEBPACK FOOTER //
// ./src/containers/Payments/Form.jsx